export const type = 'in-trip';
